<div class="image-gallery__counter" *ngIf="images.length > 1">
  Bild {{carouselComponent.currentSlideIndex + 1}} / {{images.length}}
</div>
<lib-image-carousel #carouselComponent
                    (imageChange)="imageChange.emit($event)"
                    (click)="$event.stopPropagation()"
                    [currentSlideIndex]="index"
                    [lazyLoadImages]="true"
                    [images]="images"
                    [showCounter]="false"
                    [showCredit]="false"
                    [fullScreen]="true"
                    [showAnchors]="false"></lib-image-carousel>
<button mat-icon-button
        class="image-gallery__close"
        (click)="close()">
  <mat-icon>close</mat-icon>
</button>
<div class="image-gallery__anchors" *ngIf="images.length > 1">
  <a *ngFor="let image of images; let i = index"
     [ngClass]="{active: i === carouselComponent.currentSlideIndex}"
     (click)="carouselComponent.changeImage(i); $event.stopPropagation()"></a>
</div>
<div class="image-gallery__text">
  <span *ngIf="carouselComponent.currentImageTitle"
        class="image-gallery__title">
    {{carouselComponent.currentImageTitle}}
  </span>
  <span *ngIf="carouselComponent.currentImageCredit"
        class="image-gallery__credit">
    Bild: {{carouselComponent.currentImageCredit}}
  </span>
</div>
